<!-- Modern HPS Life Landing Page -->
<div class="modern-landing-page">
  <!-- Hero Section -->
  <app-hero-section></app-hero-section>

  <!-- Features Section -->
  <app-features-section></app-features-section>

  <!-- Risk Section -->
  <app-risk-section></app-risk-section>

  <!-- Clients Section -->
  <section class="clients-section" id="contact">
    <div class="container">
      <app-clients></app-clients>
    </div>
  </section>

  <!-- Additional Sections -->
  <!-- <section id="regulatory">
    <app-regularity></app-regularity>
  </section> -->

  <section id="accessibility">
    <app-accessibility-guidance></app-accessibility-guidance>
  </section>

  <!-- Help & Support Section -->
  <!-- <section id="help-support" style="z-index:1 !important">
    <app-helpandsupport></app-helpandsupport>
  </section> -->

  <!-- Link Pages Section -->
  <!-- <section id="terms">
    <app-link-pages></app-link-pages>
  </section> -->

  <!-- Footer -->
  <section id="footer">
    <app-footer></app-footer>
  </section>
</div>